import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-75cdaa75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "app_header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header_logo_img",
  src: _imports_0,
  alt: "logo"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "header_logo_title" }, "請求管理", -1))

import { useStore } from "vuex";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const store = useStore();
const router = useRouter();

const logout = () => {
  store.dispatch("signout").then(() => {
    router.replace({ name: "signin" });
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_unref(store).state.isLoggedIn)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "header_logout_button",
          onClick: logout
        }, " ログアウト "))
      : _createCommentVNode("", true)
  ]))
}
}

})